var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caret",class:{blink: _vm.blink}},[_vm._v("_")])}
var staticRenderFns = []

export { render, staticRenderFns }